module.exports = __webpack_public_path__ + "static/media/mastercard-logo.56b92ee2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/ways-to-pay/mastercard-logo.png
// module id = 2238
// module chunks = 0